import { useSendbird } from '@sendbird/uikit-react';
import GroupChannelHandler from '@sendbird/uikit-react/handlers/GroupChannelHandler';
import { useEffect } from 'react';

const CustomGroupChannelHandler = () => {
  const {
    state: { stores },
  } = useSendbird();
  const sdk = stores?.sdkStore?.sdk;

  useEffect(() => {
    try {
      const handler = new GroupChannelHandler({
        onChannelChanged: (channel) => {
          console.log('onChannelChanged');
        },
        onChannelDeleted: (channelUrl, channelType) => {
          console.log('onChannelDeleted');
        },
        onMessageReceived: (channel, message) => {
          console.log('onMessageReceived');
        },
        onMessageUpdated: (channel, message) => {
          console.log('onMessageUpdated');
        },
        onMessageDeleted: (channel, messageId) => {
          console.log('onMessageDeleted');
        },
        onChannelFrozen: (channel) => {
          console.log('onChannelFrozen');
        },
        onChannelUnfrozen: (channel) => {
          console.log('onChannelUnfrozen');
        },
        onOperatorUpdated: (channel, users) => {
          console.log('onOperatorUpdated');
        },
        onChannelMemberCountChanged: (channels) => {
          console.log('onChannelMemberCountChanged');
        },
        onMentionReceived: (channel, message) => {
          console.log('onMentionReceived');
        },
        onReactionUpdated: (channel, reactionEvent) => {
          console.log('onReactionUpdated');
        },
        onUserJoined: (channel, user) => {
          console.log('onUserJoined');
        },
        onUserLeft: (channel, user) => {
          console.log('onUserLeft');
        },
        onUserMuted: (channel, user) => {
          console.log('onUserMuted');
        },
        onUserUnmuted: (channel, user) => {
          console.log('onUserUnmuted');
        },
        onUserBanned: (channel, user) => {
          console.log('onUserBanned');
        },
        onUserUnbanned: (channel, user) => {
          console.log('onUserUnbanned');
        },
        // ... more handlers
      });
      if (typeof sdk?.groupChannel?.addGroupChannelHandler === 'function') {
        sdk.groupChannel.addGroupChannelHandler('UNIQUE_HANDLER_ID', handler);
      }
    } catch {
      console.error('Error adding group channel handler');
    }

    // Clean up the GroupChannel handler when the component unmounts
    return () => {
      try {
        sdk.groupChannel.removeGroupChannelHandler('UNIQUE_HANDLER_ID');
      } catch {
        console.error('Error removing group channel handler');
      }
    };
  }, [sdk]);

  return null;
};

export default CustomGroupChannelHandler;
